
import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './pets.json'; // The JSON you provided

const Pets = () => {
  return (
    <div className="topic-page-container">
        {/* We can still use your Layout, but we pass the Router as children or a prop */}
        <TopicsPageLayout
            
            description="Pet ownership, animal vocabulary, and care discussions. B2 level grammar, vocabulary, and speaking exercises."
            level="B2"
            title="Pets"
            image="/Images/dogscatssmart.webp"
            seoTitle="Free English Lesson Plans: Pets"
            seoDescription="Pet ownership, animal vocabulary, and care discussions. B2 level grammar, vocabulary, and speaking exercises."
        >
            {/* Map through the JSON and render everything immediately */}
            
                {topicData.map((section, index) => (
                    <div key={index} className="lesson-section-wrapper">
                        <TopicsRouter sectionData={section} />
                    </div>
                    ))}
            
        </TopicsPageLayout>
    </div>
  );
};

export default Pets;


